'use client';

import { Suspense } from 'react';
import DealerList from '../components/DealerList';
import DealerListSkeleton from '../components/DealerListSkeleton';
import { DealerLocatorType } from '@/types/dealer';
import type { LeadForm } from '@/types/lead-forms';
import SalesCallbackProvider from '@/components/sales-callback/SalesCallbackProvider';

interface DealerListClientProps {
  locale: string;
  dealerData: DealerLocatorType | null;
  leadForms?: LeadForm[];
}

export default function DealerListClient({ locale, dealerData, leadForms }: DealerListClientProps) {
  return (
    <SalesCallbackProvider>
      <Suspense fallback={<DealerListSkeleton />}>
        <DealerList locale={locale} dealerData={dealerData} leadForms={leadForms} />
      </Suspense>
    </SalesCallbackProvider>
  );
}
